var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 1.17095 0 2.61538 0C4.05982 0 5.23077 0.895431 5.23077 2V16C5.23077 17.1046 4.05982 18 2.61538 18C1.17095 18 0 17.1046 0 16V9V2Z",
    fill: "#0573E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7692 2C11.7692 0.89543 12.9402 0 14.3846 0C15.8291 0 17 0.895431 17 2V16C17 17.1046 15.8291 18 14.3846 18C12.9402 18 11.7692 17.1046 11.7692 16V2Z",
    fill: "#0573E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.a136d95f40ecd049f77b5990125b33e1.svg";
export { ForwardRef as ReactComponent };